import * as React from 'react';
import { cn } from '../lib/utils';
import { useAnimatedNumber } from './useAnimatedNumber';
import { CHART_GROW_DURATION_MS } from '../ReferralPerformanceDashboard/chartAnimation';

function resolveDecimals(format, decimals) {
  if (decimals != null) return decimals;
  if (format === 'percent' || format === 'days' || format === 'fixed') return 1;
  return 0;
}

function formatAnimatedValue(value, format, decimals) {
  if (format === 'percent') return `${value.toFixed(decimals)}%`;
  if (format === 'days') return `${value.toFixed(decimals)} days`;
  if (format === 'fixed') return value.toFixed(decimals);
  return value.toLocaleString('en-US');
}

function AnimatedNumber({
  value,
  format = 'number',
  decimals,
  delay = 0,
  duration = CHART_GROW_DURATION_MS,
  enabled = true,
  className,
}) {
  const resolvedDecimals = resolveDecimals(format, decimals);
  const { value: animated, isEmpty } = useAnimatedNumber(value, {
    duration,
    delay,
    decimals: resolvedDecimals,
    enabled,
  });

  if (isEmpty) {
    return <span className={cn(className)}>—</span>;
  }

  return (
    <span className={cn(className)}>
      {formatAnimatedValue(animated, format, resolvedDecimals)}
    </span>
  );
}

export default AnimatedNumber;
